import { EProductType } from '@core/type';
import { DealEntity, IndicatorEntity, MediaEntity, ProductBlockEntity } from '@core/type/api';
import { SanityMedia } from '@core/type/sanity';

export type ProductCarouselLabelsProps = {
  isNew: boolean;
  isTopSales: boolean;
  deal: DealEntity;
  isEnabled: boolean;
  isOutOfStock: boolean;
};

export type ProductIndicatorProps = {
  indicator: IndicatorEntity;
  productType: EProductType;
};

export type ProductCarouselProps = Pick<
  ProductBlockEntity,
  'isNew' | 'isTopSales' | 'name' | 'deal' | 'isOutOfStock' | 'isEnabled'
> &
  ({ medias: MediaEntity[] } | { medias: SanityMedia[] });

export const enum ProductTriggerAction {
  WISHLIST = 'wishlist',
  ALERT = 'alert',
}
